<div *ngIf="checkViewMode('edit')" class="form-group switch-group">
  <label for="">
    {{attribute.key}}
    <div *ngIf="getOptionByKey(attribute,'tooltip')" class="popover-info" [popover]="getOptionByKey(attribute,'tooltip')"
    placement="right"
    container="body"
    triggers="mouseenter:mouseleave">
      <i class="fa fa-question-circle"></i>
    </div>
  </label>
  <div>
    <ui-switch [checked]="true" [disabled]="disabled ? true : false" (valueChange)="onValueChange($event)"></ui-switch>
    <label> {{getOptionByKey(attribute,'hideTitle')== 'true'? '' : attribute.key}} </label>
  </div>
</div>


<div class="m-switch-text-view" *ngIf="checkViewMode('view')&&attribute.value!=''&&attribute.value!= null">
    <div class="m-switch-text-view-container">
      <label> {{getOptionByKey(attribute,'hideTitle')== 'true'? '' : attribute.key}} </label>
      <p> {{attribute.value}}</p>
    </div>
</div>
<div class="m-switch-text-view" *ngIf="checkViewMode('view') && (attribute.value==''||attribute.value== null)">
    <div class="m-switch-text-view-container">
        <label> {{getOptionByKey(attribute,'hideTitle')== 'true'? '' : attribute.key}} </label>
        <p> Sem conteúdo</p>
      </div>

</div>
